/*
 * @Author: Latte
 * @Date: 2021-09-09 16:05:42
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-16 08:44:20
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\system\CSDocument\file.js
 */

import request from "@/utils/request";
import config from "@/utils/config";
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 前端接口:用户获取可以阅读的产品资料
 */
export function getFileListByUser(params) {
	return request({
		url: config.API_MEDICAL1 + "/Api/V1/CsFiles/UserCsFileList",
		method: "get",
		params,
	});
}

/**
 * 分页获取学习资源文件集合
 */
export function getLearningFileList(params) {
	return request({
		url: config.API_MEDICAL1 + "/Api/V1/CsFiles/LearnFileList",
		method: "get",
		params,
	});
}

/**
 * 获取所有文件列表
 *
 * @param {*} params
 */
export function getFileList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/AllCsFileList",
		method: "get",
		params,
	});
}

/**
 * @description: 根据筛选条件获取文件
 * @param {*} params
 * @return {*}
 */
export function getFileByCondition(params) {

	// axios内部会对params进行编码，所以改变get请求的传值方式，直接将参数拼接在URL上
	// 详情看源码 axios/helpers/buildURL.js
	const arr = [];
	Object.entries(params).forEach((item) => {
		// 因为where的值是一个数组，而encodeURIComponent()的参数为String，所以要对where进行toJSON操作
		if (item[0] === "where") {
			item[1] = JSON.stringify(item[1]);
		}
		arr.push(`${item[0]}=${encodeURIComponent(item[1])}`);
	});

	return request({
		url: `${config.API_ADMIN}/Api/V1/AdminDocuments/AllCsFileList?${arr.join("&")}`,
		method: "get",
	});
}

/**
 *
 *
 * @param {*} params
 */
export function getSeriesList(params) {
	var url = config.API_ADMIN + "/Api/V1/AdminDocuments/MachineSeriesList?";
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: "get",
	});
}

/**
 * 获取OSS上传信息
 *
 * @param {*} params
 */
export function getOSSUploadInfo(params) {
	return request({
		url: config.API_MEDICAL1 + "/Api/V1/ALiYunCloud/TokenAndPath",
		method: "get",
		params,
	});
}

/**
 * @description: 后台添加文档
 * @param {*} data
 * @return {*}
 */
export function addFile(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFile/Add",
		method: "post",
		data: data,
	});
}

/**
 * @description: 后台更新文件
 * @param {*} data
 * @return {*}
 */
export function editFile(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFile/Update",
		method: "patch",
		data: data,
	});
}

/**
 * @description: 后台置顶文件
 * @param {*} data
 * @return {*}
 */
export function topStatusFile(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFile/Update",
		method: "post",
		data: data,
	});
}

/**
 *
 * 删除文件
 * @param {*} params
 */
export function deleteFile(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFile/DeleteOrBack",
		method: "delete",
		params,
	});
}

/**
 *
 *
 * @param {*} params
 */
export function getFileCategoryList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/FileTypeList",
		method: "get",
		params,
	});
}

/**
 * 后台添加资源入库
 *
 * @param {*} data
 */
export function addFileCategory(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFileType/Add",
		method: "post",
		data,
	});
}

/**
 *
 *
 * @param {*} data
 */
export function editFileCategory(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFileType/Update",
		method: "patch",
		data,
	});
}

/**
 *
 *
 * @param {*} params
 */
export function deleteFileCategory(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFileType/Delete",
		method: "delete",
		params,
	});
}

/**
 *
 *
 * @param {*} params
 */
export function getMachineSeriesList(params) {
	//where需要编码，request会再编一次码（request本身的编码不会编码","等符号），所以拼接url
	var url = config.API_ADMIN + "/Api/V1/AdminDocuments/MachineSeriesList?";
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: "get",
	});
}

/**
 *
 * 新增设备
 * @param {*} data
 */
export function addMachineSeries(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/MachineSeries/Add",
		method: "post",
		data,
	});
}

/**
 *
 * 编辑设备
 * @param {*} data
 */
export function editMachineSeries(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/MachineSeries/Update",
		method: "post",
		data,
	});
}

/**
 *
 * 删除设备
 * @param {*} params
 */
export function deleteMachineSeries(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/MachineSeries/Delete",
		method: "delete",
		params,
	});
}



/**
 * @description: 添加筛选条件
 * @param {*} data
 * @return {*}
 */
export function addCondition(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/Condition/Add",
		method: "post",
		data,
	});
}

/**
 * @description: 删除筛选条件
 * @param {*} params
 * @return {*}
 */
export function deleteCondition(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/Condition/Delete",
		method: "delete",
		params,
	});
}

/**
 * @description: 更新筛选条件
 * @param {*} data
 * @return {*}
 */
export function updateCondition(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/Condition/Update",
		method: "patch",
		data,
	});
}

/**
 * @description: 获取客服文档的筛选条件
 * @param {*} params
 * @return {*}
 */
export function getConditionList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/Condition/List",
		method: "get",
		params,
	});
}

/**
 * @description: 获取单个筛选条件详情
 * @param {*} params
 * @return {*}
 */
export function getConditionDetail(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/Condition/Detail",
		method: "get",
		params,
	});
}

/**
 * @description: 后台获取文件
 *
 * @param params
 * @returns {*}
 */
export function getAllCSDocumentList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/AllCsFileList",
		method: "get",
		params,
	});
}

/**
 * 后台获取文件角色
 */
export function getCsRoleList(params) {
	return request({
		url: config.API_AUTH + '/auth/v1/role/cs/list',
		method: "get",
		params,
	});
}

/**
 * 后台获取角色
 */
export function getRoleList(params) {
	return request({
		url: config.API_AUTH + '/auth/v1/role/list',
		method: "get",
		params,
	});
}
/**
 * 获取全局配置：文档访问时间
 */
export function getCsConfig() {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsConfig",
		method: "get",
	});
}

/**
 * 全局配置更新：文档访问时间
 */
export function CsConfigUpdate(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsConfig/Update",
		method: "patch",
		data: params
	});
}

/**
 * 对用户访问文档申请的审核接口
 */
export function csFileReadRequestAudit(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminDocuments/CsFileReadReq/Audit",
		method: "post",
		data: params
	});
}

/**
 * 查询所有文档访问申请的接口
 */
export function csFileReadRequestList(params) {
	const arr = [];
	Object.entries(params).forEach((item) => {
		// 因为where的值是一个数组，而encodeURIComponent()的参数为String，所以要对where进行toJSON操作
		if (item[0] === "where") {
			item[1] = JSON.stringify(item[1]);
		}
		arr.push(`${item[0]}=${encodeURIComponent(item[1])}`);
	});
	return request({
		url: `${config.API_ADMIN}/Api/V1/AdminDocuments/CsFileReadReqList?${arr.join("&")}`,
		method: "get",
	});
}

/**
 * 更新角色对应的资料类型访问权限
 */
export function csFileRoleUpdate(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/CsFileRole/Update',
		method: "patch",
		data: params
	});
}
